/*
 |--------------------------------------------------------------------------
 | UI / mutation_types.js
 |--------------------------------------------------------------------------
 */

export const SET_IS_MOBILE = 'SET_IS_MOBILE'
export const SET_VIEWPORT_HEIGHT = 'SET_VIEWPORT_HEIGHT'
export const SET_RECOMMENDATION = 'SET_RECOMMENDATION'
export const SET_FEEDBACK = 'SET_FEEDBACK'
export const SET_MAP = 'SET_MAP'
export const SET_TRANSLATION = 'SET_TRANSLATION'
export const SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE'
export const SET_CURRENT_COORDINATES = 'SET_CURRENT_COORDINATES'
